export default "__VITE_ASSET__CPBLKt2f__"